export enum SourceOfPick {
    Upsell = 'Upsell',
    OutrightsGrid = 'OutrightsGrid',
    Other = 'Other',
    BetStationMarquee = 'BetStationMarquee',
    EventDetails = 'EventDetails',
    LineSwitcher = 'LineSwitcher',
    MultiGenerator = 'MultiGenerator',
    WorldCupHub = 'WorldCupHub',
    EmbeddedBetBuilder = 'EmbeddedBetBuilder',
    OverlayBetBuilder = 'OverlayBetBuilder',
    TeamGrouping = 'TeamGrouping',
}
